import styled from '@emotion/styled';
import moment from 'moment';
import React from 'react';
import Calendar from 'react-calendar';

const AvailabilityCalender = ({ availabilityTime = null, profile = "BabySitter", onMonthChange }) => {
    const [currentDate, setCurrentDate] = React.useState(new Date());
    const [activeMonth, setActiveMonth] = React.useState(moment().format("YYYY-MM"));

    const availabilityDateArr = Array.isArray(availabilityTime?.availability)
        ? availabilityTime.availability.map(item => new Date(item.date).getDate())
        : [];

    const handleActiveStartDateChange = ({ activeStartDate }) => {
        const newMonth = moment(activeStartDate).format("YYYY-MM");
        if (newMonth !== activeMonth) {
            setActiveMonth(newMonth);
            setCurrentDate(activeStartDate);
            if (onMonthChange) onMonthChange(newMonth);
        }
    };

    return (
        <Container>
            <Calendar
                activeStartDate={currentDate}
                onActiveStartDateChange={handleActiveStartDateChange}
                tileClassName={({ date }) => {
                    if (
                        availabilityDateArr.includes(date.getDate()) &&
                        date.getMonth() === currentDate.getMonth()
                    ) {
                        return `availabilitydateHighlight pointer ${profile === "HouseKeeper" ? "hk" : ""}`;
                    }
                    return "availabilitycalendar";
                }}
                className="availabilitycalendarHeader"
            />
        </Container>
    );
};

const Container = styled("div")`
    margin-top: 2.2rem;
`;

export default AvailabilityCalender;
